module.exports = __webpack_public_path__ + "img/e_1_5_r.79ac3a3a.png";